module.exports = __webpack_public_path__ + "static/img/mapAppImg.4ea13a7.png";